import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {goToPage, PER_PAGE, renderNextPage} from '../../actions/FlightsActions';

class FlightsPagination extends Component {

    loadedPages() {
        return Math.ceil(this.props.flights.length / PER_PAGE) || 1;
    }

    hasMore() {
        return this.props.loadedPage * PER_PAGE < this.props.count;
    }

    goTo(page) {
        if (page === this.props.viewPage) {
            return;
        }
        this.props.goToPage(page);
    }

    next() {
        if (this.props.viewPage < this.loadedPages()) {
            this.props.goToPage(this.props.viewPage + 1);
        } else if (this.hasMore()) {
            this.props.renderNextPage();
        }
    }

    chevron(flip) {
        return (
            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.2"
                 strokeLinecap="round" strokeLinejoin="round" style={flip ? {transform: 'scaleX(-1)'} : null}>
                <polyline points="6 4 12 9.5 6 15"/>
            </svg>
        );
    }

    render() {
        const pages = this.loadedPages();
        const view = this.props.viewPage;

        if (pages <= 1 && !this.hasMore()) {
            return null;
        }

        const numbers = [];
        for (let p = 1; p <= pages; p++) {
            numbers.push(
                <button key={p} type="button" className={`flights-page${p === view ? ' is-current' : ''}`}
                        onClick={() => this.goTo(p)}>
                    {p}
                </button>
            );
        }

        return (
            <div className="flights-pagination">
                <button type="button" className="flights-page" disabled={view === 1}
                        onClick={() => this.goTo(view - 1)}>
                    {this.chevron(true)}
                </button>
                {numbers}
                <button type="button" className="flights-page" disabled={view === pages && !this.hasMore()}
                        onClick={() => this.next()}>
                    {this.chevron(false)}
                </button>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        flights: state.FlightsReducer.flights,
        loadedPage: state.FlightsReducer.loadedPage,
        viewPage: state.FlightsReducer.viewPage,
        count: state.FlightsReducer.count,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        goToPage,
        renderNextPage,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightsPagination);



// WEBPACK FOOTER //
// ./src/components/flights/FlightsPagination.js